import { Button, Stack, Tab, Tabs, Typography } from "@mui/material"
import ClipboardIcon from "components/icons/other/clipboard"
import { observer } from "mobx-react-lite"
import { useContentEditorStore } from "pages/content/store"
import { useState } from "react"
import { Code } from "./styled"

const ContentCode = observer(() => {

  const contentStore = useContentEditorStore()
  const [ currentTab, setCurrentTab ] = useState("raw")

  let code = ""
  if (currentTab === "console") code = contentStore.consoleCode
  if (currentTab === "raw") code = contentStore.rawCode
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(code)
  }

  return (
    <>
      <Stack px={4}  pt={3} direction="row" alignItems="center">
        <Typography fontSize={18} fontWeight={700}>Код для вставки</Typography>
      </Stack>
      <Stack px={4} pt={1} direction="row" alignItems="flex-end" justifyContent="space-between">
        <Tabs value={currentTab} onChange={(e, val) => setCurrentTab(val)}>
          <Tab label="Console" value="console"/>
          <Tab label="Key & Value" value="raw"/>
        </Tabs>
        <Button variant="contained" onClick={copyToClipboard}>
          <ClipboardIcon sx={{ mr: 1 }}/> Копировать код
        </Button>
      </Stack>
      <Code>
        { code }
      </Code>
    </>
  )
})

export default ContentCode